export default __webpack_public_path__ + "static/media/Cart.de722b84.webp";